exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/send_to_device/bg.jpg"));

// Module
exports.push([module.id, ".S2DLayout-94c2df94{background:linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),url(" + ___CSS_LOADER_URL___0___ + ") center/cover;height:calc(100vh - 60px);display:flex;align-items:center;justify-content:center}.S2DLayout-94c2df94 p{margin-bottom:15px !important}.Modal-e415d8be{width:80vw;min-height:550px;max-width:700px}.modalContent-a3bcca02{position:relative}.Footer-9be3a3b6{display:flex;justify-content:space-between}.Footer-9be3a3b6 .stepText-1765f377{font-size:14px;font-style:italic;margin-bottom:15px}.Footer-9be3a3b6 .prev-abc13bd4{margin-right:20px}\n", ""]);

// Exports
exports.locals = {
	"S2DLayout": "S2DLayout-94c2df94",
	"Modal": "Modal-e415d8be",
	"modalContent": "modalContent-a3bcca02",
	"Footer": "Footer-9be3a3b6",
	"stepText": "stepText-1765f377",
	"prev": "prev-abc13bd4"
};